export default __webpack_public_path__ + "static/media/topItemArts.6e7eaf08.png";